import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { TurtleBeachAuthService } from './turtle-beach-auth.service';

@Injectable()
export class TurtleBeachAuthGuardService implements CanActivate {

    constructor(private authService: TurtleBeachAuthService) { }

    canActivate(): boolean {
        if (this.authService.isLoggedIn()) {
            return true;
        }

        this.authService.startAuthentication();
        return false;
    }
}
